<template>
  <div class="history">
    <div class="top">
      <div class="headline">
        <span class="title">My Subscriptions</span>
        <span class="loading">{{ loading }}</span>
      </div>
    </div>
    <div class="all-subscriptions-container">
      <table class="history-table" v-if="showHistory">
        <thead>
        <tr>
          <th>Order ID</th>
          <th>Category</th>
          <th>Created At</th>
          <th>Datasource</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(value, key) in customerSubscriptions" :key="key">
          <td>{{ value.order_id }}</td>
          <td>{{ value.category }}</td>
          <td>{{ formatDate(value.created_at) }}</td>
          <td>{{ value.title }}</td>
          <td>
            <button @click="navigateToInfo(value.order_id, value.subscription_access_token)" class="open-button">Open
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "history-view",
  data() {
    return {
      title: "All Subscriptions",
      showHistory: false,
      loading: "",
      loadingTimeout: null,
      cancelTokens: {
        getCustomerSubscriptions: axios.CancelToken.source(),
      },
    };
  },
  computed: {
    customerSubscriptions() {
      return this.$store.state.customerSubscriptions;
    },
    customer_id() {
      return this.$router.history.current.query.customer_id;
    },
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },
    navigateToInfo(order_id, subscription_access_token) {
      this.$router.push({
        path: '/subscription/info',
        query: {
          customer_id: this.customer_id,
          order_id: order_id,
          subscription_access_token: subscription_access_token
        }
      });
    },
    stopLoading() {
      clearInterval(this.loadingTimeout);
      this.loading = "";
    },
    createLoading() {
      var thisGlobal = this;
      this.loadingTimeout = window.setInterval(function () {
        if (thisGlobal.loading == "...") {
          thisGlobal.loading = "";
        } else {
          thisGlobal.loading += ".";
        }
      }, 500);
    },
  },
  mounted() {
    this.createLoading(); // Start loading indicator

    this.$store.dispatch("getCustomerSubscriptions", this.cancelTokens.getCustomerSubscriptions)
        .then(() => {
          // Once data is fetched, stop loading indicator
          this.stopLoading();
          this.showHistory = true;
        })
        .catch(error => {
          console.error("Error:", error);
          this.stopLoading();
        });
  },
  beforeDestroy() {
    this.cancelTokens.getCustomerSubscriptions.cancel("View closed");
  },
};
</script>

<style scoped>
.history {
  width: 100%;
  height: 85%;
  display: flex;
  padding-left: 40px;
  padding-right: 40px;
  flex-direction: column;
  overflow-y: auto;
}

.top .headline {
  font-size: 30px;
  margin: 20px;
}

.top {
  height: 100px;
  display: flex;
  align-items: center;
}

.all-subscriptions-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.history-table {
  width: 100%;
  border-collapse: collapse;
}

.history-table th,
.history-table td {
  text-align: center;
  padding: 8px 16px;
  border-bottom: 1px solid #e7e7e7;
}

.open-button {
  padding: 8px 16px;
  background-color: #ffc20f;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.open-button:hover {
  background-color: #ffa500;
}

</style>
